/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

// require('../../node_modules/moment/moment');

require("moment");

require("spark-bootstrap");
require("./components/bootstrap");
require("daterangepicker");
require("../../../node_modules/chart.js/dist/Chart.js");
require("../../../node_modules/chartjs-plugin-annotation/chartjs-plugin-annotation.min.js");
// require('jqvmap')
// require('../../../node_modules/jqvmap/dist/maps/jquery.vmap.world.js')

// if (process.env.NODE_ENV !== "production") {
    //   // tell webpack to load jquery-migrate, no assignment needed
    //   // tslint:disable-next-line no-var-requires
    //   require('jquery-migrate')
    // }
    
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    
const { topicSlugs, langs, sources, ratingTypes, allLabels } = require('./constants');
const EventBus = new Vue();
const GlobalState = new Vue({
    data: {
        isMobile: window.innerWidth < 768
    }
});

Object.defineProperties(Vue.prototype, {
    $eventHub: {
        get: function() {
            return EventBus;
        }
    },
    $global: {
        get: function() {
            return GlobalState;
        }
    }
});

window.addEventListener("resize", () => {
    GlobalState.isMobile = window.innerWidth < 768;
});

Vue.directive("tooltip", function(el, binding) {
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: "hover",
        html: true
    });
});

Vue.directive("click-outside", {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event, arg2) {
            // here I check that click was outside the el and his childrens

            event.clickedOutsideTarget = el;

            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    }
});

Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
    }
});

Vue.mixin({
    data() {
        return {
            lightLogos: ["trip_advisor", "booking_com", "hotels_com"]
        };
    },
    methods: {
        __(string) {
            if (typeof Spark.translations[string] !== "undefined") {
                return Spark.translations[string];
            }
            return string;
        },
        ucFirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        labelizeGeneral(string) {
            if (string in allLabels) {
                return allLabels[string];
            }

            if (string in sources) {
                return sources[string];
            }

            return this.ucFirst(string.replace(/_/g, " "));
        },
        langCodeToLabel(string) {
            return string in langs ? langs[string] : "";
        },
        goToHomeTab(tabName) {
            $('.spark-settings-tabs a[href="#' + tabName + '"]').tab("show");
        },
        sourceLabelFromSlug: slug => {
            return slug in sources ? sources[slug] : "";
        },
        allSources() {
            return sources;
        },

        getRatingType(sourceSlug) {
            return Object.keys(ratingTypes).includes(sourceSlug)
                ? ratingTypes[sourceSlug]
                : 5;
        },

        labelFromTopicSlug: slug => {
            return slug in topicSlugs ? topicSlugs[slug] : slug;
        },

        imageName(sourceName) {
            let name = sourceName;

            if (this.lightLogos.includes(name)) {
                name += "_light";
            }

            return name;
        },

        getImageSource(sourceName) {
            let name = this.imageName(sourceName);
            return "/assets/img/reviews/" + name + ".png";
        },

        getOriginalReviewFilters() {
            return {
                page: 1,
                sortBy: JSON.stringify({ published_date: "desc" }),
                fromDate: moment()
                    .subtract(365, "days")
                    .format("YYYY-MM-DD"),
                toDate: moment().format("YYYY-MM-DD"),
                dateRangeString: this.__("Last 365 Days"),
                responseFilter: "",
                importance: "",
                source: "",
                reviews: "",
                subcategory: "",
                sentimentGroup: "",
                language: "",
                countryCode: "",
                terms: "",
                keyword: "",
                sentimentCategory: "",
                positiveNegativeOrBoth: "",
                insightRolling: "",
                ratingsCategory: ""
            };
        },
        formatParamsForUrl(params) {
            let params_string = Object.keys(params)
                .map(function(k) {
                    return params[k] == ""
                        ? ""
                        : encodeURIComponent(k) +
                              "=" +
                              encodeURIComponent(params[k]);
                })
                .join("&");

            return params_string;
        },

        getDatePickerLabel(fromDate, toDate, rangeLabel, displayFormat) {
            // from/toDate formatted as YYYY-MM-DD
            var inFormat = "YYYY-MM-DD";
            var defaultOutFormat = "YYYY-MM-DD"; // 'D MMM YY'
            var outFormat = displayFormat ? displayFormat : defaultOutFormat;

            if (rangeLabel && rangeLabel != "Custom Range") {
                return rangeLabel;
            }

            return (
                moment(fromDate, inFormat).format(outFormat) +
                " to " +
                moment(toDate, inFormat).format(outFormat)
            );
        },

        getDefaultDateRanges() {
            const ranges = {};

            ranges[this.__("Yesterday")] = [
                moment().subtract(1, "days"),
                moment().subtract(1, "days")
            ];
            ranges[this.__("Last 7 Days")] = [
                moment().subtract(6, "days"),
                moment()
            ];
            ranges[this.__("Last 30 Days")] = [
                moment().subtract(29, "days"),
                moment()
            ];
            ranges[this.__("Month To Date")] = [
                moment().startOf("month"),
                moment()
            ];
            ranges[this.__("Year To Date")] = [
                moment().startOf("year"),
                moment()
            ];
            ranges[this.__("Previous year")] = [
                moment()
                    .startOf("year")
                    .subtract(1, "year"),
                moment()
                    .endOf("year")
                    .subtract(1, "year")
            ];
            ranges[this.__("All time")] = [moment("1920-01-01"), moment()];

            return ranges;
        },

        handleAxiosError(message, error, showSwal = true) {
            console.log("handleAxiosError", error);
            if ("response" in error) {
                error = error.response;
            }
            var errorMessage =
                "message" in error.data ? error.data.message : "";
            if (errorMessage.substring(0, 8) == "SQLSTATE") {
                errorMessage = "Database error";
            }
            if (!errorMessage) {
                errorMessage =
                    "_error_" in error.data ? error.data._error_.message : "";
            }
            if (errorMessage) {
                errorMessage = ": " + errorMessage;
            }
            console.log("handleAxiosError: " + message + errorMessage);

            if (showSwal) {
                swal("Error!", message + errorMessage, "error");
            }
        },
        async getJWT() {
            const response = await axios.get(
                "/api/token/" + Spark.state.currentTeam.id
            );
            const data = await response.data;
            return data.token;
        },
        sweetAlertTransientOk(text, timer = 2000) {
            swal("OK", text, "success");
            return;

            // TODO: does not show OK icon :-(
            swal({
                title: "OK",
                text: text,
                icon: "success",
                //buttons: false,
                timer: timer
            });
        },
        abbrNum(number, decPlaces) {
            // 2 decimal places => 100, 3 => 1000, etc
            decPlaces = Math.pow(10, decPlaces);

            // Enumerate number abbreviations
            var abbrev = ["k", "m", "b", "t"];

            // Go through the array backwards, so we do the largest first
            for (var i = abbrev.length - 1; i >= 0; i--) {
                // Convert array index to "1000", "1000000", etc
                var size = Math.pow(10, (i + 1) * 3);

                // If the number is bigger or equal do the abbreviation
                if (size <= number) {
                    // Here, we multiply by decPlaces, round, and then divide by decPlaces.
                    // This gives us nice rounding to a particular decimal place.
                    number =
                        Math.round((number * decPlaces) / size) / decPlaces;

                    // Handle special case where we round up to the next abbreviation
                    if (number == 1000 && i < abbrev.length - 1) {
                        number = 1;
                        i++;
                    }

                    // Add the letter for the abbreviation
                    number += abbrev[i];

                    // We are done... stop
                    break;
                }
            }

            return number;
        }
    }
});

var app = new Vue({
    mixins: [require("spark")],
    mounted() {
        this.$on("newTeam", team => {
            this.teams.push(team);
        });

        $("#dropdownMenuButtonTeams").on("click", function(event) {
            event.preventDefault();
            $(this).next(".dropdown-menu").toggleClass("show");
        });
    },
    beforeDestroy() {
        $("#dropdownMenuButtonTeams").off("click");
        this.$off("newTeam");
    }
});